<template>
    <div>
      <el-form-item label="来源">
        <el-radio-group v-model="config.source">
          <el-radio-button :label="1">词库</el-radio-button>
          <el-radio-button :label="2">自定义</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="选项">
        <el-radio-group v-model="config.leftItems">
          <el-radio-button label="words">词语</el-radio-button>
          <el-radio-button label="pinyin">拼音</el-radio-button>
          <el-radio-button label="words_pinyin">词语+拼音</el-radio-button>
          <el-radio-button label="image">图片</el-radio-button>
          <el-radio-button label="audio">音频</el-radio-button>
          <el-radio-button label="translation">翻译</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="配对选项">
        <el-radio-group v-model="config.rightItems">
          <el-radio-button label="words">词语</el-radio-button>
          <el-radio-button label="pinyin">拼音</el-radio-button>
          <el-radio-button label="words_pinyin">词语+拼音</el-radio-button>
          <el-radio-button label="image">图片</el-radio-button>
          <el-radio-button label="audio">音频</el-radio-button>
          <el-radio-button label="translation">翻译</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="选项数量">
        <el-input-number v-model="config.minItemsCount" :min="3" title="最小数量"></el-input-number>
        —
        <el-input-number v-model="config.maxItemsCount" :min="4" title="最多数量，0表示不限制"></el-input-number>
      </el-form-item>
      <el-form-item label="答题解析">
        <el-checkbox border v-model="config.showReviewsContent" label="内容说明"></el-checkbox>
        <el-checkbox border v-model="config.showReviewsGrammar" label="关联语法"></el-checkbox>
      </el-form-item>
      <el-form-item label="AI超解析">
        <el-radio-group v-model="config.aiChao">
          <el-radio-button :label="0">没有小超</el-radio-button>
          <el-radio-button :label="1">有小超没有解析</el-radio-button>
          <el-radio-button :label="2">有小超有解析</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </div>
</template>

<script>
export default {
  name: 'pdt',
  data () {
    return {
      config: {
        minItemsCount: 3,
        maxItemsCount: 4,
        showReviewsContent: false,
        showReviewsGrammar: false,
        leftItems: 'words',
        rightItems: 'words',
        source: 1,
        aiChao: 1,
      }
    }
  },
}
</script>
